import { render } from "./Popup.vue?vue&type=template&id=46e36f54&scoped=true&ts=true"
import script from "./Popup.vue?vue&type=script&lang=ts"
export * from "./Popup.vue?vue&type=script&lang=ts"

import "./Popup.vue?vue&type=style&index=0&id=46e36f54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e36f54"]])

export default __exports__